<template>
  <div class="container">
    <div class="title">
      <span class="titleHeader">{{ aboutUsInfo.title[0] }}</span>
      <span class="titleFooter">{{ aboutUsInfo.title[1] }}</span>
    </div>
    <div class="sutitle">
      <div class="icon">
        <img class="subtitleIcon" :src="aboutUsInfo.icon" alt="">
      </div>
      <div class="line"></div>
      <div class="sutitleText">{{ aboutUsInfo.sutitle }}</div>
    </div>
    <div class="content">
      <img class="picture" :src="aboutUsInfo.picture" alt="">
      <div class="companyProfile">
        <div class="companyProfileTitle">{{ aboutUsInfo.companyProfile.title }}</div>
        <div class="companyProfileDesc">{{ aboutUsInfo.companyProfile.desc }}</div>
      </div>
    </div>
    <div class="visonFooter">
      <div class="visonTitle">{{ aboutUsInfo.vision.title }}</div>
      <ul>
        <li v-for="(item,index) in aboutUsInfo.vision.list" :key="index">{{ item }}</li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "AboutUs",
  props: {
    aboutUsInfo: {
      type: Object, defaults() {
        return {}
      }
    }
  },
  data() {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  background-color: #2A45A7;

  .title {
    padding-top: 200px;
    margin: 0 auto;
    font-size: 64px;
    font-family: "SourceHanSansSC-Bold-2";
    font-weight: bold;
    color: #EAFF74;

    .titleHeader {
      color: #FFFFFF;
    }
  }

  .sutitle {
    height: 130px;
    margin: 160px 0;
    display: flex;
    align-items: center;

    .icon {
      flex: 1;
      display: flex;
      justify-content: flex-end;

      .subtitleIcon {
        width: 438px;
        height: 81.69px;
      }
    }
    
    .line {
      width: 1px;
      height: 130px;
      background-color: #FFFFFF;
      margin: 0 59px;
    }

    .sutitleText {
      flex: 1;
      font-size: 56px;
      font-family: "SourceHanSansSC-Bold-2";
      font-weight: bold;
      color: #FFFFFF;
      text-align: left;
    }
  }

  .content {
    position: relative;

    .picture {
      width: 1400px;
      height: 668.56px;
      border-radius: 24px;
    }

    .companyProfile {
      position: absolute;
      box-sizing: border-box;
      top: 534px;
      left: 764px;
      width: 840px;
      background: #E43363;
      border-radius: 24px;
      padding: 95px 116px;

      .companyProfileTitle {
        text-align: left;
        font-size: 48px;
        font-family: "SourceHanSansSC-Bold-2";
        font-weight: bold;
        color: #FFFFFF;
      }

      .companyProfileDesc {
        color: #FFFFFF;
        text-align: left;
        margin-top: 40px;
        font-size: 24px;
        font-family: "SourceHanSansSC-Bold-2";
        font-weight: bold;
      }
    }
  }

  .visonFooter {
    margin-top: 78px;
    margin-left: 260px;
    padding-bottom: 208px;

    .visonTitle {
      text-align: left;
      font-size: 48px;
      font-family: "SourceHanSansSC-Bold-2";
      font-weight: bold;
      color: #FFFFFF;
      opacity: 0.5;
    }

    ul {
      margin-top: 51px;
    }

    li {
      width: 400px;
      word-wrap: break-word;
      margin: 10px 0;
      margin-left: 40px;
      list-style-type: disc;
      text-align: left;
      font-size: 24px;
      font-family: "SourceHanSansSC-Bold-2";
      font-weight: bold;
      color: #FFFFFF;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/homepage/childComps/AboutUs.vue